import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { ADD_ARTWORK_FORM, ADD_PRINT_REQUEST, ADD_PRINT_TRANS, GET_ARTWORK_FORM, GET_CHECK_INTENT, GET_PRINTER_FROM_PRODUCT, GET_PRINTER_LIST, GET_PRINTING_REQUESTS_OWNER_ID, GET_PRINTING_REQUESTS_USER_ID, PRINT_REQUEST_TRANS, WITHDRAW_REQUEST_SELLER } from "./actionTypes";
import { addPrintRequestFail, addPrintRequestSuccess, addPrintTranasctionFail, addPrintTranasctionSuccess, getArtworkFormFail, getArtworkFormSuccess, getCheckOutIntentFail, getCheckOutIntentSuccess, getPrinterFromProductFail, getPrinterFromProductSuccess, getPrinterListFail, getPrinterListSuccess, getPrintRequestsOwnerIdFail, getPrintRequestsOwnerIdSuccess, getPrintRequestsUserIdFail, getPrintRequestsUserIdSuccess, postWithdrawRequestSellerFail, postWithdrawRequestSellerSuccess, printReqTransFail, printReqTransSuccess } from "./actions";
import { addArtworkFormApi, addPrintRequestApi, addPrintTransApi, getArtworkFormApi, GetCheckoutIntentApi, getPinterProductApi, getPrinterListApi, getPrintReqOwnerApi, getPrintRequestsFormUserIdApi, postWithdrawRequestSellerApi, printReqTransFailApi } from "helpers/backend_helper";
import moment from "moment"
function* AddPrintRequest({ payload: { data, callback } }) {
  try {
    const response = yield call(addPrintRequestApi, data);
    console.log("creditcardres", response)
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(addPrintRequestFail(response.message));
    }
    return yield put(addPrintRequestSuccess(response.data));

  } catch (error) {
    console.log("error", error);
    yield put(addPrintRequestFail(""));
  }
}



function* getPrinterFromProduct({ payload: { data, callback } }) {
  try {
    const response = yield call(getPinterProductApi, data);
    if (response.status === "failure") {
      return yield put(getPrinterFromProductFail(response.message));
    }
    yield put(getPrinterFromProductSuccess(response.data));
    callback && callback(response);

  } catch (error) {
    console.log("error", error);
    yield put(getPrinterFromProductFail(""));
  }
}

function* getPrintRequestsFormUserId({ payload: { data, callback } }) {
  try {
    const response = yield call(getPrintRequestsFormUserIdApi, data);
    if (response.status === "failure") {
      yield put(getPrintRequestsUserIdFail(response.message));
      callback && callback(response);
    }
    response.data = response?.data?.map((tr) => {
      tr.order_tracking_status?.forEach((item) => {
        let localtime = moment(item.date).local();
        item.date = localtime.format('YYYY-MM-DD');
        // console.log("kjdsjfkldhgjkvncvmnvjkfdbgjfd", item.date)
      });
      return tr; // Return the modified tr
    });
    callback && callback(response);
    yield put(getPrintRequestsUserIdSuccess(response.data));

  } catch (error) {
    console.log("error", error);
    yield put(getPrintRequestsUserIdFail(error.message));
  }
}

function* getPrintRequestFromOwnerId({ payload: { data, callback } }) {
  try {
    const response = yield call(getPrintReqOwnerApi, data);
    if (response.status === "failure") {
      yield put(getPrintRequestsOwnerIdFail(response.message));
      callback && callback(response);
    }
    yield put(getPrintRequestsOwnerIdSuccess(response.data));
    callback && callback(response);

  } catch (error) {
    console.log("error", error);
    yield put(getPrintRequestsOwnerIdFail(error.message));
  }
}

function* addPrintTrans({ payload: { data, callback } }) {
  try {
    const response = yield call(addPrintTransApi, data);
    if (response.status === "failure") {
      yield put(addPrintTranasctionFail(response.message));
    }
    yield put(addPrintTranasctionSuccess(response.data));
    callback && callback(response);

  } catch (error) {
    console.log("error", error);
    yield put(addPrintTranasctionFail(error.message));
  }
}


function* addArtworkForm({ payload: { data, callback } }) {
  try {
    const response = yield call(addArtworkFormApi, data);

    if (response.status === "failure") {
      callback && callback(response);
      yield put(addPrintTranasctionFail(response.message));
    }
    yield put(addPrintTranasctionSuccess(response.data));
    callback && callback(response);

  } catch (error) {
    console.log("error", error);
    yield put(addPrintTranasctionFail(error.message));
  }
}

function* getArtworkForm({ payload: { data, callback } }) {
  try {
    const response = yield call(getArtworkFormApi, data);
    if (response.status === "failure") {
      callback && callback(response);
      yield put(getArtworkFormFail(response.message));
    }
    yield put(getArtworkFormSuccess(response.data));
    callback && callback(response);

  } catch (error) {
    console.log("error", error);
    yield put(getArtworkFormFail(error.message));
  }
}

function* getPrinterList({ payload: { data, callback } }) {
  try {
    const response = yield call(getPrinterListApi, data);
    if (response.status === "failure") {
      callback && callback(response);
      yield put(getPrinterListFail(response.message));
    }
    yield put(getPrinterListSuccess(response.data));
    callback && callback(response);

  } catch (error) {
    console.log("error", error);
    yield put(getPrinterListFail(error.message));
  }
}




function* GetCheckoutIntent({ payload: { data, callback } }) {
  try {
    const response = yield call(GetCheckoutIntentApi, data);
    callback && callback(response);
    if (response.status === "failure") {
      yield put(getCheckOutIntentFail(response.message));
    }
    yield put(getCheckOutIntentSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(getCheckOutIntentFail(error.message));
  }
}



function* sellerWithdrawRequest({ payload: { data, callback } }) {
  try {
    const response = yield call(postWithdrawRequestSellerApi, data);
    callback && callback(response);
    if (response.status === "failure") {
      yield put(postWithdrawRequestSellerFail(response.message));
    }
    yield put(postWithdrawRequestSellerSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(postWithdrawRequestSellerFail(error.message));
  }
}

function* printRequestTrans({ payload: { data, callback } }) {
  try {
    const response = yield call(printReqTransFailApi, data);
    callback && callback(response);
    if (response.status === "failure") {
      yield put(printReqTransFail(response.message));
    }
    yield put(printReqTransSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(printReqTransFail(error.message));
  }
}







function* PrintSaga() {
  yield takeEvery(ADD_PRINT_REQUEST, AddPrintRequest);
  yield takeEvery(GET_PRINTER_FROM_PRODUCT, getPrinterFromProduct);
  yield takeEvery(GET_PRINTING_REQUESTS_USER_ID, getPrintRequestsFormUserId);
  yield takeLatest(ADD_PRINT_TRANS, addPrintTrans);
  yield takeLatest(ADD_ARTWORK_FORM, addArtworkForm);
  yield takeLatest(GET_ARTWORK_FORM, getArtworkForm);   
  yield takeLatest(GET_PRINTING_REQUESTS_OWNER_ID, getPrintRequestFromOwnerId);
  yield takeLatest(GET_PRINTER_LIST, getPrinterList);
  yield takeLatest(GET_CHECK_INTENT, GetCheckoutIntent);
  yield takeLatest(WITHDRAW_REQUEST_SELLER, sellerWithdrawRequest);
  yield takeLatest(PRINT_REQUEST_TRANS, printRequestTrans);
}

export default PrintSaga;
